import { render, staticRenderFns } from "./CardTroubleshoot.vue?vue&type=template&id=36dd9c7f&scoped=true&"
import script from "./CardTroubleshoot.vue?vue&type=script&lang=js&"
export * from "./CardTroubleshoot.vue?vue&type=script&lang=js&"
import style0 from "./CardTroubleshoot.vue?vue&type=style&index=0&id=36dd9c7f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dd9c7f",
  null
  
)

export default component.exports